module.exports = function(angularModule) {

  angularModule.factory('contactDownloadService', function ($q, $http, $rootScope) {

    function ContactDownloadService() {
    }
    ContactDownloadService.prototype.exportContacts = function (campaignId) {
      var params = {campaignId: campaignId};
      return $http.get('/v5/reviewBuilder/contact/export', {params: params}).then(function(response) { return response.data });
    };

    return new ContactDownloadService();
  })
}

